<script>
import DibbleAPI from "../../../api";
import DibbleJS from "../../../dibble";
import DibbleApi from "../../../api";
import Vue from 'vue';
import VTooltip from 'v-tooltip';

Vue.use(VTooltip);

const BOAT_STATUS_UPDATE = {
    ON_RENT: 1,
    DONE: 2,
    LATE: 3,
    CANCELLED: 4
}

export default {
    name: "MoorageOrder",
    data() {
        return {
            dibbleJs: DibbleJS,
            orderId: this.$route.params.id,
            order: null,
            orderOrigin: null,
            isShowModal: false,
            boatExtras: [],
            extraIdValues: [],
            currentStateForBoatId: 0,
            currentStatus: 0,
            BOAT_STATUS_UPDATE: BOAT_STATUS_UPDATE,
            modalIdRequires: [BOAT_STATUS_UPDATE.ON_RENT, BOAT_STATUS_UPDATE.DONE, BOAT_STATUS_UPDATE.CANCELLED],
            definedCheckoutImagesList: [],
            checkoutAgreementList: []
        }
    },
    created() {
        this.loadOrderInfo()
    },
    methods: {
        loadOrderInfo() {
            const params = {
                request: DibbleAPI.api.getMoorageMarinaOrder,
                order_id: this.orderId
            }
            DibbleJS.showLoader();
            DibbleJS.callApiRequest(params, this._onLoadOrderSuccess, this._onLoadOrderFailed)
        },
        _onLoadOrderSuccess(response) {
            DibbleJS.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                this.order = this.orderOrigin = response
            } else {
                DibbleJS.toastErrorMessage(response.message)
            }
        },
        _onLoadOrderFailed() {
            DibbleJS.hideLoader();
            DibbleJS.toastErrorMessage('Something wrong! can not load data');
        },
        formatOrderDateTime(dateStr) {
            return this.$moment(dateStr, 'YYYY-MM-DD hh:mm:ss').format("MM/DD/YYYY hh:mm");
        },
        changeBoatOrderStatus(boatId, status) {
            if (status === BOAT_STATUS_UPDATE.CANCELLED) {
                this.cancelRentalBoat(boatId)
            } else {
                this.currentStateForBoatId = boatId
                this.currentStatus = status
                this.$refs.checkOutOutModal.resetTheForm()

                let boat_extras = this.orderOrigin.order_info.boats.find(boat => boat.boat_id === boatId)
                const extras = typeof boat_extras == 'undefined' ? [] : boat_extras.boat_extras

                const boat = this.orderOrigin.order_info.boats.find(boat => boat.boat_id === boatId)

                const modalData = {
                    order_id: this.orderId,
                    boatId: boatId,
                    boat: boat,
                    extras: extras
                }

                this.$emit('setModalData', modalData);
                this.isShowModal = true
            }
        },
        cancelRentalBoat(boatId) {
            DibbleJS.confirmBox('Are you sure you want to cancel this order boat?', () => {
                DibbleJS.showLoader()
                DibbleJS.callApiRequest({
                    request: DibbleApi.api.cancelRentalBoat,
                    order_id: this.orderId,
                    boat_id: boatId,
                }, response => {
                    DibbleJS.hideLoader();
                    if (DibbleApi.isResponseSuccess(response)) {
                        DibbleJS.toastSuccessMessage(response.message)
                        this.loadOrderInfo()
                    } else {
                        DibbleJS.toastErrorMessage(response.message)
                    }
                })
            })
        },
        onGetRentalBoatExtras(){
            const params = {
                request: DibbleAPI.api.getRentalBoatExtras,
                boat_type: this.order.order_info.boat_type
            }
            DibbleJS.callApiRequest(params, this._onBoatExtrasSuccess)
        },

        _onBoatExtrasSuccess(response){
            if (DibbleApi.isResponseSuccess(response)) {
                const { boat_extras, checkout_images_list } = response
                this.boatExtras = boat_extras
                this.definedCheckoutImagesList = checkout_images_list
                for (let i in this.boatExtras) {
                    this.extraIdValues.push({
                        id: this.boatExtras[i].boat_extra_id,
                        value: this.boatExtras[i].default_amount ? '' : false,
                        amount: this.boatExtras[i].price
                    })
                }
                this.checkoutAgreementList = response['client_checkout_list']
            } else {
                DibbleJS.toastErrorMessage(response.message)
            }
        },

        onCloseModal() {
            this.loadOrderInfo()
            this.isShowModal = false
        },

        handleModalListener(data) {
            this.isShowModal = false
            switch (data.action) {
                case 'updateBoatStatus': {
                    DibbleJS.showLoader();
                    const params = {...data.params};
                    params.order_id = this.$route.params.id
                    params.boat_id = this.currentStateForBoatId

                    DibbleJS.callApiRequest(params, (response) => {
                        DibbleJS.hideLoader();
                        if (DibbleAPI.isResponseSuccess(response)) {
                            DibbleJS.toastSuccessMessage(response.message)
                            this.loadOrderInfo()
                        } else {
                            DibbleJS.toastErrorMessage(response.message)
                        }
                    }, this._onLoadOrderFailed)
                    break;
                }

                default:
                    console.log("Unknown request.")
            }
        }
    },
    computed: {
        extraBoatWaterEquipment() {
            return this.boatExtras.filter(b=> b.is_water_sport_equipment)
        },
        extraBoatNormalEquipment() {
            return this.boatExtras.filter(b=> !b.is_water_sport_equipment)
        },
    }
}
</script>
<template src="./template/index.html"></template>
<style scoped>
.user-license-image {
    max-width: 300px;
    border-radius: 5px;
}
</style>
